
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tunisie-telecom",
      function () {
        return require("private-next-pages/tunisie-telecom.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tunisie-telecom"])
      });
    }
  